export default __webpack_public_path__ + "static/media/Standard17.e7a9bf08.png";